const UNCATEGORISED_LABEL = 'Other documents'

/*
 * The progress screen lists document types, not files: a brand can upload a
 * dozen assets under one type and a dozen spinners says nothing useful. The
 * status endpoint reports per file, so files are folded back onto the
 * `document_category` they were uploaded under, and a type keeps its spinner
 * until every file beneath it is done.
 */
export const toExtractionProgressItems = (documents = []) => {
  const byCategory = documents.reduce((types, { category, isExtracting }) => {
    const label = category || UNCATEGORISED_LABEL
    const existing = types.get(label)
    types.set(label, {
      fileCount: (existing?.fileCount || 0) + 1,
      id: label,
      isExtracting: Boolean(existing?.isExtracting) || Boolean(isExtracting),
      label,
    })
    return types
  }, new Map())

  return [...byCategory.values()]
}

// What the progress screen actually lists. Until the first status response
// lands there are no files to report, so the brand's document types stand in
// as placeholders — all still to do. Once the endpoint answers it is the only
// source: it names exactly the files extraction is working through, and a
// type it never mentions had nothing uploaded against it.
export const toExtractionProgressList = ({
  documents = [],
  documentTypes = [],
} = {}) => {
  const extracted = toExtractionProgressItems(documents)
  if (extracted.length > 0) return extracted

  return documentTypes.map(({ id, label }) => ({
    id,
    isExtracting: true,
    label,
  }))
}
